export default __webpack_public_path__ + "static/media/iphone11.eedfcf44.jpg";